import React from "react";
import { ApplicantFormSuccess } from "../../templates/ApplicantFormSuccess";
import mail_sent from "../../../assets/images/mail_sent.svg";
import logo from "../../../assets/images/new_logo_dark.svg";
const ApplicantFormSuccessPage = () => {
  const header: string = "Congratulations!";
  const firstText: string =
    "Thank you for taking the time to accomplish the form.";
  const secondText: string =
    "We will notify you soon on the result of your application. Please check your email regularly.";
  const firstTextMobile: string =
    "Thank you for taking the time to answer the questions.";
  const secondTextMobile: string =
    "Your application has been sent to us. We will notify you of the result of your application. Please check your email for our response.";
  return (
    <ApplicantFormSuccess
      mailImage={mail_sent}
      logoImage={logo}
      header={header}
      firstText={firstText}
      secondText={secondText}
      firstTextMobile={firstTextMobile}
      secondTextMobile={secondTextMobile}
    />
  );
};

export default ApplicantFormSuccessPage;
